export const MedicalSpecialties = [
  "Adolescent Medicine",
  "Allergy and Immunology",
  "Anesthesiology",
  "Cardiology",
  "Cardiothoracic Surgery",
  "Cardiovascular Medicine",
  "Child and Adolescent Psychiatry and Psychotherapy",
  "Clinical Neurophysiology",
  "Critical Care",
  "Dermatology",
  "Emergency Medicine",
  "Endocrinology",
  "Family Medicine",
  "Gastroenterology",
  "General Practice",
  "General Surgery",
  "Geriatrics",
  "Gynecology",
  "Health Informatics",
  "Hematology",
  "Hepatology",
  "Hospice Care",
  "Hospitalist",
  "Hyperbaric Medicine",
  "Infection Prevention",
  "Infectious Diseases",
  "Internal Medicine",
  "Interventional Radiology",
  "Microbiology",
  "Neonatology",
  "Nephrology",
  "Neurology",
  "Neuroradiology",
  "Neurosurgery",
  "Nuclear medicine",
  "Obstetrics",
  "Obesity Medicine",
  "Occupational Medicine",
  "Oncology",
  "Ophthalmology",
  "Oral and Maxillofacial Surgery",
  "Oral Health",
  "Orthopedics",
  "Other",
  "Otolaryngology",
  "Otorhinolaryngology",
  "Pain Medicine",
  "Palliative Care",
  "Pathology",
  "Pediatric Allergy and Immunology",
  "Pediatric Cardiology",
  "Pediatric Endocrinology and Diabetes",
  "Pediatric Gastroenterology, Hepatology and Nutrition",
  "Pediatric Hematology and Oncology",
  "Pediatric Infectious Diseases",
  "Pediatric Nephrology",
  "Pediatric Respiratory Medicine",
  "Pediatric Rheumatology",
  "Pediatrics",
  "Pediatric Surgery",
  "Physical and Rehabilitation Medicine",
  "Plastic, Reconstructive and Aesthetic Surgery",
  "Podiatry",
  "Psychiatry",
  "Public Health",
  "Pulmonology",
  "Radiology",
  "Radiotherapy",
  "Rheumatology",
  "Sleep Medicine",
  "Sports Medicine",
  "Surgery and Perioperative Care",
  "Urology",
  "Vascular Medicine",
  "Vascular Surgery",
  "Women's Health",
  "Wound Care",
];

export const NursingSpecialties = [
  "Administration",
  "Ambulatory",
  "Behavioral Health",
  "Cardiovascular/Cardiac",
  "Critical Care",
  "Dermatology",
  "Education",
  "Emergency & Trauma",
  "Endocrinology",
  "Gastroenterology",
  "Gynecology",
  "Health Informatics",
  "Home Care",
  "Hospice & Palliative Care",
  "Infectious Disease",
  "Infusion",
  "Leadership/Management",
  "Long-Term Care",
  "Medical/Surgical",
  "Neonatology",
  "Nephrology",
  "Neurology",
  "Nutrition Services",
  "Obstetrics",
  "Oncology",
  "Ophthalmic",
  "Orthopedics",
  "OR/PACU/Perioperative",
  "Other",
  "Pediatrics",
  "Pediatric Critical Care",
  "Physical and Rehabilitation Medicine",
  "Public Health",
  "Psychology",
  "Quality",
  "Respiratory Care",
  "School",
  "Speech Language Therapy",
  "Telemetry",
  "Urology",
  "Wound Care",
];
